<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Kolekcja champions</h3>
    </app-contentpageheader>
    <app-champions />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";

import Champions from "../../components/collections/types/Champions.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/common/wood.jpg")
    };
  },
  components: {
    "app-champions": Champions,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
